import React, { useEffect } from 'react'
import { CollectionView } from '@grapecity/wijmo';
import * as wjrGrid from '@grapecity/wijmo.react.grid';
import { CellMaker } from "@grapecity/wijmo.grid.cellmaker";
import { typeVisits } from '../../../../api/helpline/qa';

interface Prop {
  visitsInfo: typeVisits[] | undefined | null,
  handleClickQAno: (num: string) => void,
}

const VisitsInfo: React.FC<Prop> = (props) => {
  const { visitsInfo, handleClickQAno } = props

  const [data, setData] = React.useState<CollectionView<any> | boolean>(false)

  const toQAedit = (ctx: string) => {
    if (ctx) {
      handleClickQAno(ctx)
    }
  }


  useEffect(() => {
    if (visitsInfo && visitsInfo.length !== 0) {
      setData(new CollectionView(visitsInfo, {
        sortDescriptions: [{ property: "keiyakuKikan", ascending: false }],
        groupDescriptions: ["keiyakuKikan"]
      }))
    } else {
      setData(false)
    }
  }, [visitsInfo])

  return (
    <React.Fragment>
      {data &&
        <wjrGrid.FlexGrid alternatingRowStep={0} itemsSource={data} autoRowHeights={true} isReadOnly={true} allowMerging={'Cells'}>
          <wjrGrid.FlexGridColumn binding="keiyakuKikan" header="契約期間" wordWrap={true} visible={false}></wjrGrid.FlexGridColumn>
          <wjrGrid.FlexGridColumn binding="qaNo" header="質問番号" wordWrap={true} allowMerging={true} minWidth={120} align="center" cellTemplate={CellMaker.makeButton({ click: (event: any, ctx) => toQAedit(ctx.value) })}></wjrGrid.FlexGridColumn>
          <wjrGrid.FlexGridColumn binding="answeSt" header="訪問日時" wordWrap={true} format="d" align="center"></wjrGrid.FlexGridColumn>
          <wjrGrid.FlexGridColumn binding="aPersonName" header="訪問者" wordWrap={true} align="center"></wjrGrid.FlexGridColumn>
          <wjrGrid.FlexGridColumn binding="answerClsName" header="訪問種類" wordWrap={true} align="center" minWidth={160}></wjrGrid.FlexGridColumn>
          <wjrGrid.FlexGridColumn binding="qaStatusClsName" header="対応状況" wordWrap={true} align="center"></wjrGrid.FlexGridColumn>
        </wjrGrid.FlexGrid>}
    </React.Fragment>
  )
}

export default VisitsInfo